import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DataService {

  constructor() { }

  private readonly appdet = new BehaviorSubject<{name: '', appId: 0}>({
    name: '',
    appId: 0,
  });
  /**
   * setting Application info
   */
  setNewAppInfo(data) {
    this.appdet.next(data);
  }
  /**
   * getting Application info
   */
  getNewAppInfo() {
    return this.appdet.asObservable();
  }
}
